import React from 'react';
import Alert from '@mui/material/Alert';
import { useAuth, ROLES, getUserRole } from '../contexts/AuthContext';

/**
 * Banner de contexto:
 * - FISCAL puro → visão restrita ao setor
 * - Coordenador/Analista Financeiro → monitoramento (leitura) de todos os setores
 */
export default function VisaoRestritaBanner({ setorOverride }) {
  const { user, rbacRole, fiscalSetor, isCoordenadorFinanceiro, isAnalistaFinanceiro } = useAuth();
  const role = rbacRole || getUserRole(user);
  const setor = setorOverride || fiscalSetor || user?.setor;

  if (role === ROLES.FISCAL_MONITOR || isCoordenadorFinanceiro) {
    return (
      <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
        Visão de monitoramento: você visualiza os contratos e documentos de{' '}
        <strong>todos os setores</strong> (somente leitura). Atuação como fiscal
        {setor ? (
          <>
            {' '}restrita ao setor <strong>{setor}</strong>
          </>
        ) : (
          ' do Financeiro'
        )}
        .
      </Alert>
    );
  }

  if (role === ROLES.FINANCEIRO_ANALISTA || isAnalistaFinanceiro) {
    return (
      <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
        Visão financeira: acesso de leitura aos contratos e documentos de{' '}
        <strong>todos os setores</strong>, com ações financeiras. Sem edição de
        contratos.
      </Alert>
    );
  }

  if (role !== ROLES.FISCAL || !setor) return null;

  return (
    <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
      Visão Restrita: Você está visualizando apenas os dados referentes ao setor{' '}
      <strong>{setor}</strong>.
    </Alert>
  );
}
